import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Order } from 'src/models/DTO/V2/orders/Order';
import { OrderResponse } from 'src/models/DTO/V2/orders/OrderResponse';
import {
  LocalstorageserviceService
} from 'src/services/infrastructureServices/localstorageservice/localstorageservice.service';
import { DocumentsService } from 'src/services/requestServices/V2/documents/documents.service';
import { ImagesService } from 'src/services/requestServices/images/images.service';
import { PartnersService } from 'src/services/requestServices/partners/partners.service';
import { ProductService } from 'src/services/requestServices/products/product.service';
import { SearchService } from 'src/services/requestServices/search/search.service';
import { UsersService } from 'src/services/requestServices/users/users.service';
import { CarrierService } from 'src/services/requestServices/V2/carrier/carrier.service';
import { ImageService } from 'src/services/requestServices/V2/image/image.service';
import { InfoService } from 'src/services/requestServices/V2/info/info.service';
import { OrdersService } from 'src/services/requestServices/V2/orders/orders.service';
import { LoggeduserinfoService } from 'src/services/stateServices/loggeduserinfoservice/loggeduserinfo.service';
import { UserinfostoreService } from 'src/services/stateServices/userinfoservice/userregistrationstateservice.service';
import { LoggedinfoService } from 'src/services/stateServices/V2/loggedinfo/loggedinfo.service';
import { BaseDashboardComponent } from '../base-dashboard/base-dashboard.component';
import { Convertor } from 'src/infrastructure/convertorHelpers/convertor';
import { ToastrService } from 'ngx-toastr';
import { ShipmentService } from 'src/services/requestServices/V2/shipment/shipment.service';
import { OrderCancellationReasons, OtherOrderCancellationReason } from 'src/config/labels/cancelOrderReasons';
import { OrderRessourceLine } from 'src/models/DTO/V2/orders/OrderRessourceLine';

import { LoadingstateService } from 'src/services/stateServices/loading/loadingstate.service';
import { OrderStatus } from 'src/config/labels/orderStatus';
import { Fees } from 'src/config/labels/fees';
import { ShippingMethod } from 'src/config/labels/shippingMethod';
import { OrderStatusColors } from 'src/config/labels/orderStatusColors';
import { environment } from 'src/environments/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Successes } from 'src/config/labels/successes';
import { ErrorTranslations } from 'src/config/labels/errorTranslations';
import { DispatchTypes } from 'src/config/labels/dispatchTypes';
import { ShipmentStatus } from 'src/config/labels/shipmentStatus';


@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})
export class OrderComponent extends BaseDashboardComponent implements OnInit, AfterViewInit {

  @ViewChild('cancelWindow') _cancelWindowmodal: ElementRef;
  @ViewChild('returnWindow') _returnWindow: ElementRef;
  public displayedColumnsForProductTable: string[];
  public displayedColumnsForCancledProductTable: string[];
  public displayedColumnsForReturnedProductTable: string[];

  public ordersDataSource: OrderRessourceLine[] = [];
  public returnedOrdersDataSource: OrderRessourceLine[] = [];
  public cancelledOrdersDataSource: OrderRessourceLine[] = [];
  public numberPerPageValue = -1;
  public page = 0;
  public status = 'active';
  public expandedElement: Order | null;
  public isOrderReturn = false;
  public totalRequestRefund = 0;
  public  amountRequestedInput = 0;
  public  formattedAmountRequestedInput = '0.00';
  public readonly cancellationReasons = OrderCancellationReasons;
  public cancellationReason = '';
  public cancellationComment = '';

  private _defaultOrdersPage = '1';
  private _pageNumber = 1;
  private _searchString = '';
  private _searchType = 'name.contains';
  private _initialNumberOfLoadedPages = 3;
  private _maxPage = 100;
  private _scrolling = false;
  private _currentOpenWindow?: NgbModalRef = null;
  private _selectedOrderLine: OrderRessourceLine;

  private _order: OrderResponse;


  constructor(
    protected activatedRoute: ActivatedRoute,
    protected userStateService: UserinfostoreService,
    protected localStorageService: LocalstorageserviceService,
    protected loggeduserinfoservice: LoggeduserinfoService,
    protected partnersService: PartnersService,
    protected productService: ProductService,
    protected usersService: UsersService,
    protected router: Router,
    protected imagesService: ImagesService,
    protected sanitizer: DomSanitizer,
    protected loggedInfoService: LoggedinfoService,
    protected infoService: InfoService,
    private ordersService: OrdersService,
    protected imageService: ImageService,
    private searchingService: SearchService,
    protected carrierService: CarrierService,
    protected documentsService: DocumentsService,
    private toastrService: ToastrService,
    private shipmentService: ShipmentService,
    private loadingState: LoadingstateService,
    private modalService: NgbModal,
    private toatsrService: ToastrService

  ) {
    super(activatedRoute, userStateService, localStorageService, usersService, loggeduserinfoservice,
      partnersService, imagesService, sanitizer, router, loggedInfoService, infoService, imageService, carrierService, documentsService);
    this.pageName = 'orders';
    const initialSelection = [];
    const allowMultiSelect = true;

    this.loadingState.loading$.subscribe(result => {
      this.isLoading = result;
    });
    this.displayedColumnsForProductTable = ['Product', 'Quantity', 'PricePerPiece', 'Net', 'Vat', 'Price', 'Total', 'action'];
    this.displayedColumnsForCancledProductTable = ['Product', 'Quantity', 'PricePerPiece', 'Net', 'Vat', 'Price', 'Total'];
    this.displayedColumnsForReturnedProductTable = ['Product', 'Quantity', 'PricePerPiece', 'Net', 'Vat', 'Price', 'Total'];


  }

  private loadImageForLine(line: OrderRessourceLine): void {
    if (line.sku) {
      this.imageService.getImagesPerProduct('SKU', line.sku.uuid).subscribe(images => {
        if (!images.data.length) {
          this.imageService.getImagesPerProduct('PRODUCT', line.sku.product.uuid).subscribe(img => {
            if (img.data.length) {
              line.imageSource = img.data[0]?.original.url;
            }
          });
        }
        else {
          line.imageSource = images.data[0]?.original.url;
        }
      });
    }
  }

  private loadImagesForOrdersCollection(order: OrderResponse): void {
      order.data.lines.forEach(line => {
        this.loadImageForLine(line);
    });
  }

  private fixPaymentValues(order: OrderResponse): OrderResponse {
    order.data.amount_captured = Convertor.convertNumbers.addToFixedSuffix(order.data.amount_captured, 2);
    order.data.amount_refunded = Convertor.convertNumbers.addToFixedSuffix(order.data.amount_refunded, 2);
    order.data.amount_reserved = Convertor.convertNumbers.addToFixedSuffix(order.data.amount_reserved, 2);
    order.data.total_gross = Convertor.convertNumbers.addToFixedSuffix(order.data.total_gross, 2);
    order.data.total_net = Convertor.convertNumbers.addToFixedSuffix(order.data.total_net, 2);
    order.data.total_tax_amount = Convertor.convertNumbers.addToFixedSuffix(order.data.total_tax_amount, 2);
    order.data.shipment_cost = Convertor.convertNumbers.addToFixedSuffix(order.data.shipment_cost, 2);
    order.data.voucher_amount = Convertor.convertNumbers.addToFixedSuffix(order.data.voucher_amount, 2);
    order.data.lines.forEach(line => {
      line.price_per_piece = Convertor.convertNumbers.addToFixedSuffix(line.price_per_piece , 2);
      line.single_gross = Convertor.convertNumbers.addToFixedSuffix(line.single_gross , 2);
      line.single_net = Convertor.convertNumbers.addToFixedSuffix(line.single_net, 2);
      line.single_tax_amount = Convertor.convertNumbers.addToFixedSuffix(line.single_tax_amount, 2);
      line.total_gross = Convertor.convertNumbers.addToFixedSuffix(line.total_gross, 2);
      line.total_net = Convertor.convertNumbers.addToFixedSuffix(line.total_net, 2);
      line.total_tax_amount = Convertor.convertNumbers.addToFixedSuffix(line.total_tax_amount, 2);
    });
    if (order.data.orderReturn){
      order.data.orderReturn.amount_refunded = Convertor.convertNumbers.addToFixedSuffix(order.data.orderReturn.amount_refunded, 2);
      order.data.orderReturn.amount_requested = Convertor.convertNumbers.addToFixedSuffix(order.data.orderReturn.amount_requested, 2);
    }
    return order;
  }

  private loadOrderData(orderId: string): void {
    this.ordersService.getOrder(orderId).subscribe(order => {
      console.log('this.isOrderReturn', this.isOrderReturn);
      console.log('order', order.data);
      const canceledStatus = 'cancelled';
      const shipment = order.data.shipment as any;
      const shipmentData = shipment?.data ?? shipment;
      order.data.shipment = Array.isArray(shipmentData)
        ? shipmentData
        : shipmentData
          ? [shipmentData]
          : [];
      order = this.fixPaymentValues(order);
      this._order = order;
      // This was tmp change to check the returned orders
      // this._order.data.state = 'returned';
      this.loadImagesForOrdersCollection(this._order);
      this.ordersDataSource = this._order.data.lines.filter(line => line.state !== canceledStatus);
      this.returnedOrdersDataSource = this.getReturnedItems(this._order.data);
      console.log('this.returnedOrdersDataSource --->', this.returnedOrdersDataSource);
      console.log('this.ordersDataSource1 --->', this.ordersDataSource);
      this.cancelledOrdersDataSource = this._order.data.lines.filter(line => line.state === canceledStatus);
      this.ordersDataSource.forEach(line => {
        if (line.quantity !== line.initial_quantity) {
          const clonedLine = { ...line };
          this.loadImageForLine(clonedLine);
          clonedLine.quantity = clonedLine.initial_quantity - clonedLine.quantity;
          this.cancelledOrdersDataSource.push(clonedLine);
        }
      });
      console.log('this.ordersDataSource2 --->', this.ordersDataSource);
      this.ordersDataSource.map(line => line.editable = true);
      this.cancelledOrdersDataSource.map(line => {
        line.editable = true;
        if (line.quantity === 0) {
          line.quantity = line.initial_quantity - line.quantity;
        }
      });
      this.totalRequestRefund = this.calculateRequestRefund();
      if (this.ordersDataSource.length) {
        this.ordersDataSource.push({
          editable: false,
          uuid: '',
          state: '',
          price_per_piece: '0.00',
          quantity: 0,
          initial_quantity: 0,
          total_gross: '0.00',
          total_tax_amount: '',
          total_net: this.getNetShipmentConst,
          single_gross: this._order.data.shipment_cost,
          single_tax_amount: '0.00',
          single_net: this.getNetShipmentConst,
          options: [],
          sku: {
            uuid: '',
            sku: '',
            options: [],
            product: {
              uuid: '',
              name: 'Доставка',
              state: '',
              description: {
                bg: ''
              },
              guarantee_in_months: 0,
              organisation: {
                uuid: '',
                native_name: '',
                name_in_latin: '',
                requirements: [],
                delivery_to_address_price: '',
                delivery_to_courier_office_price: '',
                free_delivery_after_order_amount: '',
                number: 0
              },
              category: {
                uuid: '',
                name: ''
              },
              brand: {
                uuid: '',
                name: ''
              },
              skus: [],
              options: [],
              total_available_quantity: 0,
              total_reserved_quantity: 0,
              created_at: '',
              updated_at: '',
              vat_percentage: this._order.data.lines[0].sku.product.vat_percentage
            }
          }
        });
      }
    });
  }

  ngOnInit(): void {
    this.getUrlParams().subscribe((params) => {
      const orderId = params?.params?.id;
      this._defaultOrdersPage = params?.params?.currentorderpage;

      const currentTab = this.getCurrentTab();
      console.log('Текущ таб ->', currentTab);
      this.isOrderReturn = currentTab === 'returned';

      if (orderId) {
        this.loadOrderData(orderId);
      }
    });
  }

  ngAfterViewInit(): void {
    this.loadTooltips();
  }

  private getCurrentTab(): string {
    return this.localStorageService.getLocalStorageItem(environment.lsOrderTab) || 'waiting';
  }

  public getReturnedItems(order: any): any[] {
    if (!order.orderReturn || !order.orderReturn.items) {
      return [];
    }

    const returnedItems = [];

    for (const returnItem of order.orderReturn.items){
      const match = order.lines.find((line: any) => line.uuid === returnItem.order_line.uuid);

      if (match) {
        const returnedLine = { ...match, quantity: returnItem.quantity, editable: true };
        this.loadImageForLine(returnedLine);
        returnedItems.push(returnedLine);
      }
    }

    return returnedItems;
  }

  public goToOrders(): void {
    this.router.navigate(['/dashboard/orders/' + this._defaultOrdersPage]);
  }

  public getLineTotalAmount(line: OrderRessourceLine): number {
    if (!line.editable) {
      return Number(this._order?.data?.shipment_cost || 0);
    }

    return Number(line.total_gross || 0);
  }

  public getCancelledTotalAmount(line: OrderRessourceLine): number {
    return Number(((line.quantity || 0) * Number(line.price_per_piece || 0)).toFixed(2));
  }

  public getReturnedTotalAmount(line: OrderRessourceLine): number {
    return Number(((line.quantity || 0) * Number(line.price_per_piece || 0)).toFixed(2));
  }

  public getPriceForFirstRange(line: OrderRessourceLine): string | 0 {
    return line.sku.product.pricing.find(pricing => pricing.quantity_from === 1 && pricing.quantity_to === 1).price_per_piece || 0;
  }

  public convertVatPercentage(line: OrderRessourceLine): number {
    return Number.parseInt(line.sku.product.vat_percentage, 10);
  }

  public buildAddressDetails(address: any): any {
    if (address.street_name === '-') {
      return address.address_line_2;
    }
    return address.street_name + ' ' + address.street_number + ((address.address_line_2) ? ', ' + address.address_line_2 : '');
  }

  public convertOrderStatus(orderStatus: string): any {
    if (this.isOrderReturn) {
      const returnMap: Record<string, string>  = {
        confirmed: OrderStatus.returnedConfirmed,
        cancelled: OrderStatus.returnedCancelled,
        waiting: OrderStatus.returnedWaiting
      };
      return returnMap[orderStatus] || OrderStatus[orderStatus];
    }else if (this.isPrinted()) {
      return OrderStatus.prined;
    }
    return OrderStatus[orderStatus];
  }

  public checkGroupType(isGroup: object | null): 'Лична' | 'Групова' {
    if (!isGroup) {
      return 'Лична';
    }
    return 'Групова';
  }

  get groupCount(): string {
    return this._order?.data?.group?.participants_count + ' души/' + this._order?.data?.group?.quantity_reserved + ' броя';
  }

  get currentShipment(): any {
    return this._order?.data?.shipment?.[0] || null;
  }

  get shipment(): any {
    return this.currentShipment?.ref_1 || null;
  }

  get shipmentStatus(): string {
    const shipment = this.currentShipment;
    if (!shipment) {
      return '-';
    }

    const legacyPreDeliveryStates = ['default', 'pending', 'request_pickup', 'dispatched', 'out_for_delivery'];
    if (this._order?.data?.state === 'delivered' &&
        !shipment.current_carrier_status &&
        legacyPreDeliveryStates.includes(shipment.state)) {
      return ShipmentStatus.delivered;
    }

    const status = shipment.current_carrier_status || shipment.state;
    return ShipmentStatus[status] || shipment.last_track_and_trace_carrier_code_note || status || '-';
  }

  get shipmentStatusNote(): string {
    return this.currentShipment?.last_track_and_trace_carrier_code_note || '-';
  }

  get getNetShipmentConst(): string {
    // tslint:disable-next-line:max-line-length
    return Convertor.convertNumbers.addToFixedSuffix(Number.parseFloat(this._order?.data.shipment_cost) / (Number.parseInt(this._order?.data.lines[0].sku.product.vat_percentage, 10) / 100 + 1), 2);
  }

  get orderStatusColor(): any {
    if (this.isOrderReturn) {
      const returnMap: Record<string, string>  = {
        confirmed: OrderStatusColors.returnedConfirmed,
        cancelled: OrderStatusColors.returnedCancelled,
        waiting: OrderStatusColors.waiting
      };
      return returnMap[this.order?.data?.orderReturn.state];
    }
    return OrderStatusColors[this.order?.data?.state];
  }

  get ShareMeReturn(): number {
    return (this.order.data?.total_net) ? Number.parseFloat(this.order.data?.total_net) * environment.ShareMeReturnTax : 0;
  }

  get order(): OrderResponse {
    return this._order;
  }

  get orderTotal(): number {
    return Number((
      Number(this.order?.data?.shipment_cost || 0) +
      Number(this.order?.data?.total_gross || 0)
    ).toFixed(2));
  }

  get classForSensitiveInfo(): string {
    if (this._order.data.state === 'waiting' || this._order.data.delivery_address.mobile_phone_1.includes('*')) {
      return 'col-sm-8 column blurry-text';
    }
    return 'col-sm-8 column';
  }

  get selectedOrderLine(): OrderRessourceLine {
    return this._selectedOrderLine;
  }

  get isOtherCancellationReason(): boolean {
    return this.cancellationReason === OtherOrderCancellationReason;
  }

  get canCancelOrderLine(): boolean {
    return this.cancellationReason.length > 0
      && (!this.isOtherCancellationReason || this.cancellationComment.trim().length > 0);
  }

  public canCancelLine(line: OrderRessourceLine): boolean {
    const orderState = this.order?.data?.state;

    return !!line?.editable
      && orderState === 'waiting'
      && line.state === 'waiting';
  }

  get orderRightPanel(): string {
    if (this.order?.data?.state === 'waiting') {
      return 'to_confirm';
    }
    else if (this.order?.data?.state === 'cancelled') {
      return 'cancelled';
    }
    else if (this.order?.data?.state === 'completed') {
      return 'completed';
    }
    else if (
      !['waiting_payment', 'cancelled'].includes(this.order?.data?.state) &&
      this.currentShipment?.uuid
    ) {
      return 'with_shipment';
    }
    else {
      return 'normal';
    }
  }

  get cancellationFee(): string {
    const fees = this._order?.data?.organisation_fees || [];
    const total = fees
      .filter(fee => fee.type === Fees.ORDER_CANCELATION_TYPE_FEE)
      .reduce((sum, fee) => sum + (Number.parseFloat(fee.gross_fee_amount) || 0), 0);

    return total > 0 ? this.formatPrice(-Math.abs(total)) : '-';
  }

  get deliveredFee(): string {
    const fee = this._order?.data?.organisation_fees?.find(
      feeTmp => feeTmp.type === Fees.ORDER_DELIVERY_TYPE_FEE
    )?.gross_fee_amount;

    return fee ? this.formatPrice(-Math.abs(Number(fee))) : '-';
  }

  private isPrinted(): boolean {
    return !!this.currentShipment?.is_printed;
  }

  public shouldShowPickUpBtn(order: any): boolean {
    return !!(
      this.loggedPartner?.data?.organisations?.[0] &&
      this.loggedPartner?.data?.organisations?.[0].carrier_accounts?.data?.[0]?.settings?.dispatch_parcel_from === DispatchTypes.organisation &&
      order?.shipment &&
      order?.shipment[0]?.number_of_parcels
    );
  }

  public orderVariationsIfAny(orderLine: OrderRessourceLine): any[] {
    if (!orderLine.sku.options.length) {
      return [];
    }
    const orderLineOptions = [];
    orderLine.sku.options.forEach(orderOption => {
      const displayName = orderOption.option.display_name;
      orderOption.option.values.forEach(possibleOptionValue => {
        if (possibleOptionValue.uuid === orderOption.value) {
          orderLineOptions.push({ name: displayName, value: possibleOptionValue.value});
        }
      });
    });
    return orderLineOptions;
  }

  public getEndDate(date: any): {date: string, time: string} {
      const newDate = this.addDays(new Date(date), 14);
      return this.convertDate(newDate);
  }

  public addDays(date: Date, days: number): string {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result.toString();
  }

  public convertDate(date: string): {date: string, time: string} {
    return Convertor.convertDate.convertDateTimeWithDelimiter(date, '/');
  }

  public convertDateOrder(date: string): {date: string, time: string} {
    return Convertor.convertDate.convertDateTimeWithDelimiter(date, '.');
  }

  public confirmOrder(): void {
    this.ordersService.confirmOrder(this.order.data.uuid, { number_of_parcels: 1 }).subscribe(() => {
      this.toatsrService.success(Successes.confirmedOrder[this.language]);
      this.loadOrderData(this.order.data.uuid);
    });
  }

  public paymentType(orderPaymentCode: string): 'С карта' | 'Наложен платеж' {
    if (orderPaymentCode === 'card') {
      return  'С карта';
    }
    return 'Наложен платеж';
  }

  public isCOD(orderPaymentCode: string): boolean {
    return orderPaymentCode !== 'card';
  }

  public generateShipment(): void {
    const shipmentUuid = this.currentShipment?.uuid;
    if (!shipmentUuid) {
      return;
    }

    this.shipmentService.updateParcels({ number_of_parcels: 1 }, shipmentUuid).subscribe(() => {
      this.shipmentService.createShipment(shipmentUuid).subscribe(() => {
        this.loadOrderData(this.order.data.uuid);
      });
    });
  }

  public printWayBill(): void {
    const shipmentUuid = this.currentShipment?.uuid;
    if (!shipmentUuid) {
      return;
    }

    this.shipmentService.printWayBill(shipmentUuid).subscribe((response) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(response);
      a.download = 'Waybill.pdf';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      this.toastrService.success('Успешно генериран документ');
    });
  }

  public printStockReciept(): void {
    this.ordersService.downloadOrderDocument(this.order.data.uuid).subscribe((response) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(response);
      a.download = 'Stock.pdf';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      this.toastrService.success('Успешно генериран документ');
    });
  }

  public cancel(): void {
    if (!this.canCancelOrderLine) {
      return;
    }

    this.ordersService.cancelOrderLine(
      this._selectedOrderLine.uuid,
      {
        reason: this.cancellationReason,
        new_quantity: this._selectedOrderLine.quantity - 1,
        comment: this.isOtherCancellationReason ? this.cancellationComment.trim() : undefined
      }
    ).subscribe(() => {
      this._currentOpenWindow.close();
      this.loadOrderData(this.order.data.uuid);
      this.toatsrService.success(Successes.cancledOrder[this.language]);
      this._selectedOrderLine = null;
      this.resetCancellationForm();
    }, (error) => {
      this.toatsrService.error(ErrorTranslations.translate(error.error.exception.message, this.language));
      this._selectedOrderLine = null;
    });
  }

  public cancelOrderLine(orderLine: OrderRessourceLine): void {
    this.resetCancellationForm();
    this._selectedOrderLine = orderLine;
    this._currentOpenWindow = this.modalService.open(this._cancelWindowmodal, { centered: true } );
  }

  private resetCancellationForm(): void {
    this.cancellationReason = '';
    this.cancellationComment = '';
  }

  convertShipmentMethod(shipmentKey: any): any {
    return ShippingMethod[this._language][shipmentKey];
  }

  public calculateRequestRefund(): number {
    const order = this.order?.data;

    if (!order?.orderReturn || !Array.isArray(order.orderReturn.items)) {
      return 0;
    }

    const total = order.orderReturn.items.reduce((sum, item) => {
      const quantity = Number(item.quantity || 0);
      const price = Number(item.order_line?.single_gross || 0);

      return sum + quantity * price;
    }, 0);

    return Number(total.toFixed(2));
  }

  confirmReturn(): void {
    if (Number(this.formattedAmountRequestedInput) > this.totalRequestRefund){
      this.toatsrService.warning('Не може да възстановите повече от сумата на върнатите продукти');
      return;
    }
    this._currentOpenWindow.close();
    this.ordersService.confirmReturn(
      this.order.data.orderReturn.uuid, Number(this.formattedAmountRequestedInput)
    ).subscribe(() => {
      this.loadOrderData(this.order.data.uuid);
      this.toatsrService.success('Успешо одобрихте сумата за връщане');
    }, (res) => {
      console.log('error', res.error.message);
      this.toatsrService.error('Нещо се обърка. Моля опитайте по - късно.');
    });
  }

  public openReturnOrderDialog(event: { stopPropagation: () => void; }): void {
    this.amountRequestedInput = this.totalRequestRefund;
    this.formattedAmountRequestedInput = Number(this.amountRequestedInput).toFixed(2);
    this._currentOpenWindow = this.modalService.open(this._returnWindow, { centered: true } );
    event.stopPropagation();
  }

  get returnWindowTitle(): string {
    if (this.order.data.paymentMethod.code === 'card') {
      return 'Възстановяване на сума';
    }
    return 'Въведете сумата, която сте възстановили';
  }

  get returnWindowText(): string {
    if (this.order.data.paymentMethod.code === 'card') {
      return 'Сумата ще бъде възстановена от ShareMe и ще бъде удържана от следващото изплащане';
    }
    return 'При поръчка платена с наложен платеж, следва да възстановите сумата по посочената от клиента банкова сметка.';
  }

  get returnPriceText(): string {
    if (this.order.data.paymentMethod.code === 'card') {
      return 'Сума за възстановяване:';
    }
    return 'Възстановена сума:';
  }
  get returnButtonTitle(): string {
    if (this.order.data.paymentMethod.code === 'card') {
      return 'Възстанови';
    }
    return 'Въведи';
  }

  onAmountInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let rawValue = input.value;

    rawValue = rawValue.replace(/[^0-9.]/g, '');

    const dotIndex = rawValue.indexOf('.');
    if (dotIndex !== -1) {
      rawValue = rawValue.substring(0, dotIndex + 1) + rawValue.substring(dotIndex + 1).replace(/\./g, '');
    }

    this.formattedAmountRequestedInput = rawValue;
  }

  onAmountKeyDown(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];
    const numberKeys = /^[0-9]$/;

    if (allowedKeys.includes(event.key)) {
      return;
    }

    const inputEl = event.target as HTMLInputElement;
    const inputValue = inputEl.value || '';
    const parts = inputValue.split('.');

    if (numberKeys.test(event.key)) {
      if (parts.length > 1 && parts[1].length >= 2) {
        const cursorStart = inputEl.selectionStart || 0;
        const cursorEnd = inputEl.selectionEnd || 0;
        const dotPosition = inputValue.indexOf('.');

        if (cursorStart > dotPosition && cursorStart === cursorEnd) {
          event.preventDefault();
          return;
        }
      }
      return;
    }

    if (event.key === '.') {
      if (inputValue.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    event.preventDefault();
  }

  onAmountBlur(): void {
    let value = this.formattedAmountRequestedInput || '';

    value = value.replace(/[^0-9.]/g, '');

    const parts = value.split('.');

    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    if (parts.length > 1 && parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2);
      value = parts.join('.');
    }

    if (value === '' || value === '.') {
      value = '0';
    }

    let parsed = Number(value);

    if (isNaN(parsed)) {
      parsed = 0;
    }

    const maxAmount = Number(this.order.data?.orderReturn?.amount_requested || 0);

    // if (parsed > maxAmount) {
    //   parsed = maxAmount;
    // }

    if (parsed < 0) {
      parsed = 0;
    }

    this.amountRequestedInput = parsed;
    this.formattedAmountRequestedInput = parsed.toFixed(2);
  }

  public getRefundFee(): string {
    const total = (this.order?.data?.organisation_fees || [])
      .filter(fee => fee.type === Fees.ORDER_REFUND_TYPE_FEE)
      .reduce((sum, fee) => sum + (Number.parseFloat(fee.gross_fee_amount) || 0), 0);

    return total > 0 ? this.formatPrice(-Math.abs(total)) : '-';
  }

  public getDeliveryRevertFee(): string {
    const total = (this.order?.data?.organisation_fees || [])
      .filter(fee => fee.type === Fees.ORDER_DELIVERY_REVERT_TYPE_FEE)
      .reduce((sum, fee) => sum + (Number.parseFloat(fee.gross_fee_amount) || 0), 0);

    return total !== 0 ? this.formatPrice(Math.abs(total)) : '-';
  }

}
